export const buttons = () => {
  const buttonLinks = document.querySelectorAll('.wp-block-button__link.wp-element-button');
  buttonLinks.forEach((buttonLink) => {
    // Get the text content
    const textContent = buttonLink.textContent.trim();

    // Set the data-label attribute
    buttonLink.setAttribute('data-label', textContent);

    // Create a new span element and set its text content
    const spanElement = document.createElement('span');
    spanElement.textContent = textContent;

    // Clear the original text content of the button link
    buttonLink.textContent = '';

    // Append the span element to the button link
    buttonLink.appendChild(spanElement);
  });
};
